import { gql } from '@apollo/client'

export const LOOKUP_TABLE_QUERY = gql`
  query lookupTables($sortBy: LookupTableSort, $filter: LookupTableFilter) {
    lookupTables(sortBy: $sortBy, filter: $filter) {
      collection {
        id
        lookupType
        value
        systemValue
        sort
        __typename
      }
    }
  }
`
